module.exports = __webpack_public_path__ + "img/262-a7e355.png";